import React from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import Button from './Button';

type GoogleSignInTypes = {
  clientId: string,
  userType: string,
  redirectUrl: string,
  classes?: string,
  switchAccounts?: boolean,
};

const GoogleSignIn = ({ redirectUrl, userType, classes, clientId, switchAccounts = false }: GoogleSignInTypes) => (
  <GoogleOAuthProvider clientId={clientId}>
    <Button
      classes={classes}
      redirectUrl={redirectUrl}
      switchAccounts={switchAccounts}
      userType={userType}
    />
  </GoogleOAuthProvider>
);

export default GoogleSignIn;
